module.exports = __webpack_public_path__ + "static/media/qrcode-belem.fe74da0c.png";